module.exports = __webpack_public_path__ + "media/backgrounds/ian-simmonds-kRLXoi3Dtqs-unsplash-f8d46194.jpg";